<template>
  <div class="mb-3">
    <v-layout wrap>
      <v-flex xs12>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Filter User Groups"
          single-line
          hide-details
        />
        <v-data-table
          :headers="userGroupTableHeaders"
          :items="userGroups"
          :search="search"
          class="elevation-1"
          disable-pagination
          hide-default-footer
        >
          <template v-slot:item="props">
            <tr>
              <td class="justify-center">
                <v-btn icon class="mx-0" @click="editUsersByUserGroup(props.item)">
                  <v-icon color="primary">edit</v-icon>
                </v-btn>
              </td>
              <td>{{ props.item.userGroupName }}</td>
              <td>{{ props.item.userGroupDesc }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
    <manage-users-by-user-group-modal />
  </div>
</template>

<script>
import ManageUsersByUserGroupModal from './ManageUsersByUserGroupModal'
import { mapMutations, mapActions } from 'vuex'
export default {
  name: 'manage-users-by-user-group',
  components: {
    ManageUsersByUserGroupModal
  },
  props: {
    userGroups: Array
  },
  data() {
    return {
      search: '',
      userGroupTableHeaders: [{
        text: 'Action',
        value: false,
        sortable: false
      },
      {
        text: 'User Group',
        value: 'userGroupName'
      },
      {
        text: 'User Group Description',
        value: 'userGroupDesc'
      }
      ]
    }
  },
  methods: {
    ...mapActions('manageUsers', ['getUsersForUserGroup', 'getUserHistoryForUserGroup']),
    ...mapMutations('manageUsers', ['setShowUsersModal', 'setShowUserGroupModal']),
    editUsersByUserGroup(selectedUserGroup) {
      this.getUsersForUserGroup(selectedUserGroup)
      this.getUserHistoryForUserGroup(selectedUserGroup)
      this.setShowUserGroupModal(true)
    }
  }
}
</script>

<style lang="scss" scoped>
  .add-text-color {
    color: $color-success;
  }

  .remove-text-color {
    color: $color-danger
  }
</style>
